import { render, staticRenderFns } from "./qr-card.vue?vue&type=template&id=a35c7f52&scoped=true"
import script from "./qr-card.vue?vue&type=script&lang=js"
export * from "./qr-card.vue?vue&type=script&lang=js"
import style0 from "./qr-card.vue?vue&type=style&index=0&id=a35c7f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35c7f52",
  null
  
)

export default component.exports